import { Component, type ReactNode } from 'react';

/**
 * Última red: un error al pintar no puede dejar la pantalla en blanco sin
 * salida. Los datos viven en IndexedDB y no se tocan; recargar suele bastar, y
 * si no, al menos se sabe que no se ha perdido nada.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: unknown): void {
    console.error('Error al pintar la app', error);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <div
        role="alert"
        className="mx-auto flex min-h-dvh max-w-lg flex-col justify-center gap-4 px-4"
      >
        <h1 className="text-xl font-bold">Algo ha fallado al abrir esta pantalla</h1>
        <p className="text-sm text-[var(--color-text-muted)]">
          Tus datos siguen guardados en este dispositivo: no se ha borrado nada. Prueba a recargar.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="tap rounded-xl bg-[var(--color-brand-button)] px-4 font-semibold text-[var(--color-on-brand)]"
        >
          Recargar
        </button>
      </div>
    );
  }
}
